module.exports = __webpack_public_path__ + "img/error4.66444786.png";